module.exports = __webpack_public_path__ + "assets/img/xiaoBoGe.1f9451e7.png";